import React from 'react';
import PropTypes from 'prop-types';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMConst from 'lib/SMConst';

class SMMessageNoticeView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      reservation: this.props.reservation,
    };
  }
  
  trackPageEvent() {
    if (this.props.isOwner) {
      SMTrackHelper.pageEvent('od change inquiry_to_reservation_3');
    }
  }
  
  renderOwner() {
    let reservation = this.props.reservation,
        user = reservation.user,
        owner = reservation.owner,
        rows = [];
    if (reservation.method == SMConst.ReservationMethod.Inquiry) {
      rows.push(
        <ul className="dashboard-message__info-list">
          <li>{I18n.t("dashboard.text_000614")}</li>
          <li>{I18n.t("dashboard.text_000617")}<a onClick={this.trackPageEvent.bind(this)} href={Routes.edit_owner_dashboard_reservation_path(owner.username, reservation.uid)}>{I18n.t("dashboard.label_000147")}</a>{I18n.t("dashboard.text_000616")}</li>
        </ul>
      );
    } else {
      rows.push(<p key="1">{I18n.t("dashboard.text_000069")}</p>);
    }
    return rows;
  }
  
  renderUser() {
    let reservation = this.props.reservation,
        user = reservation.user,
        owner = reservation.owner,
        rows = [];
    if (reservation.method == SMConst.ReservationMethod.Inquiry) {
      rows.push(
        <ul className="dashboard-message__info-list">
          <li>{I18n.t("dashboard.text_000614")}</li>
          <li>{I18n.t("dashboard.text_000615")}<a href={Routes.space_room_reservations_path(reservation.room.space.username, reservation.room.uid, {inquiry_id: reservation.uid})}>{I18n.t("dashboard.label_000147")}</a>{I18n.t("dashboard.text_000616")}</li>
        </ul>
      );
    } else {
      rows.push(<p key="1">{I18n.t("dashboard.text_000069")}</p>);
    }
    return rows;
  }
  
  render() {
    let rows = (this.props.isOwner) ? this.renderOwner() : this.renderUser();
    if (rows.length > 0) {
      return (<div className="dashboard-message__info">{rows}</div>);
    }
    return <div />;
  }
}

SMMessageNoticeView.propTypes = {
  isOwner: PropTypes.bool.isRequired,
  reservation: PropTypes.object.isRequired,
};
export default SMMessageNoticeView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMMessageNoticeView.jsx